


let PYOItems = JSON.parse(localStorage.getItem('PYOItems')) || [];

var discounted = document.querySelectorAll('.discounted');
var originalPriceCp = document.querySelectorAll('.orginal_price_cp');
var discounted10 = document.querySelectorAll('.discounted_10');
var discountedCp = document.querySelectorAll('.discounted_cp');
var discounted10Cp = document.querySelectorAll('.discounted_10_cp');

let FreqItems = [];


let qtyChangeBtn = document.querySelectorAll('[data-qty-btn]');
let qtyIncreaseBtn = document.querySelectorAll('[data-increase-qty]');

let qtyInputs = document.querySelectorAll('[data-qty-input]');
let progressItems = document.querySelectorAll('.summary-progreebar .progress-item');
let progressItemsSticky = document.querySelectorAll('.sticky-progressbar .progress-item');


let checkoutBtn = document.querySelectorAll('[data-checkout-pack]');

let removeBtn = document.querySelectorAll('[data-remove-pack]')

function savePYOItems() {
    localStorage.setItem('PYOItems', JSON.stringify(PYOItems));
}
let detch = document.querySelector('.image-popup');
if (detch !== null && detch !== undefined) {
  document.querySelector('body').appendChild(detch);
}

// let zoomImageEls = document.querySelectorAll('.pyo-products-selection .card-img');

// zoomImageEls.forEach((img) => {
//   img.addEventListener('click', (event) => {
//     event.preventDefault();

//     // Get the data-img attribute directly from the closest anchor tag of the image
//     let zoomImageSrc = event.target.closest('.card').querySelector('a').getAttribute('data-img');
    
//     if (zoomImageSrc) {
//       document.querySelector('[data-zoom-img]').src = zoomImageSrc;
//       document.querySelector('.image-popup').classList.add('open');

//       // Temporarily disable body click events to avoid immediate close
//       document.body.classList.add('disable-click');

//       // Re-enable body clicks after a short delay
//       setTimeout(() => {
//         document.body.classList.remove('disable-click');
//       }, 300); // Adjust delay as necessary
//     }
//   });
// });

let zoomImageEls = document.querySelectorAll('.pyo-products-selection .card-img img');

zoomImageEls.forEach((img) => {
  img.addEventListener('click', (event) => {
    event.preventDefault();

    // Get the data-img attribute directly from the closest anchor tag of the image
    let zoomImageSrc = event.target.closest('.card').querySelector('a').getAttribute('data-img');
    
    if (zoomImageSrc) {
      document.querySelector('[data-zoom-img]').src = zoomImageSrc;
      document.querySelector('.image-popup').classList.add('open');
    }
  });
});

// Function to close the popup
function closePopup() {
  document.querySelector('[data-zoom-img]').src = '';
  document.querySelector('.image-popup').classList.remove('open');
}

// Close popup on clicking the close button
document.querySelector('.close-image-popup').addEventListener('click', (event) => {
  event.preventDefault();
  closePopup();
});

// Close popup on clicking the overlay
document.querySelector('.popup-overlay').addEventListener('click', () => {
  closePopup();
});






let zoomBtn = document.querySelectorAll('.card-zoom');
zoomBtn.forEach((ele) => {
  ele.addEventListener('click', (event) => {
     event.preventDefault();
     const currentTab = event.currentTarget;
     let zoomimage = currentTab.closest('a').getAttribute('data-img');
     document.querySelector('[data-zoom-img]').src = zoomimage;
     document.querySelector('.image-popup').classList.add('open');
  });
});




// document.querySelector('.close-image-popup').addEventListener('click', (event) => {
//    event.preventDefault();
//    document.querySelector('[data-zoom-img]').src = '';
//    document.querySelector('.image-popup').classList.remove('open');
// });
// Function to close the popup




document.body.addEventListener('click', async (event) => {
    if (event.target.closest('.close-icon')) { 
        const button = event.target.closest('.close-icon');
        let variantID = button.getAttribute('data-remove-pack');
        
        let cartData = await getCartData();
        let cartItems = cartData.items;

        // Find the cartItem that matches the variantID
        const cartItem = cartItems.find(item => item.id === parseInt(variantID));

        // Check the quantity of the matched cartItem
        if (cartItem) {
            if (cartItem.quantity > 1) {
                // If quantity is more than 1, remove one item
                let leftqty = cartItem.quantity - 1;
                removeItem(variantID, leftqty);
            } else {
                // If quantity is 1 or less, remove zero items (or whatever your logic is)
                removeItem(variantID, 0);
            }
        }

        // Remove item from PYOItems array
        const index = PYOItems.findIndex(item => item.id === variantID);
        if (index !== -1) {
            // Remove the item at the found index
            PYOItems.splice(index, 1);

            // Save updated array to localStorage
            localStorage.setItem('PYOItems', JSON.stringify(PYOItems));

            // Re-render selectionHTML to update the UI
            loadPYOItems();
        }
    }
});


document.addEventListener("rebuy:smartcart.line-item-removed", (event) => {
    loadPYOItems();
});

console.log('items',PYOItems);

// document.addEventListener("rebuy:smartcart.line-item-increase", (event) => {
//     updatePYO('increase');
// });

// document.addEventListener("rebuy:smartcart.line-item-decrease", (event) => {
//     updatePYO('decrease');
// });

function getCartData() {
  return fetch(window.Shopify.routes.root + 'cart.js', {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json'
    }
  })
  .then(response => {
    if (!response.ok) {
      throw new Error('Network response was not ok');
    }
    return response.json();
  })
  .catch((error) => {
    console.error('Error fetching cart data:', error);
  });
}

// async function updatePYO(action) {
//   let cartData = await getCartData();
//   let cartItems = cartData.items;

//   if (action === 'increase') {
//     // Increase the quantity of matching items in PYOItems
//     cartItems.forEach(cartItem => {
//       let matchingItem = PYOItems.find(pyoItem => pyoItem.id === cartItem.id.toString());
//       if (matchingItem) {
//         matchingItem.quantity += 1; // Increase quantity
//       }
//     });
//   } else if (action === 'decrease') {
//     // Decrease the quantity of matching items in PYOItems
//     cartItems.forEach(cartItem => {
//       let matchingItem = PYOItems.find(pyoItem => pyoItem.id === cartItem.id.toString());
//       if (matchingItem) {
//         matchingItem.quantity -= 1; // Decrease quantity

//         // If quantity reaches 0, remove the item from PYOItems
//         if (matchingItem.quantity <= 0) {
//           PYOItems = PYOItems.filter(item => item.id !== matchingItem.id);
//         }
//       }
//     });
//   }

//   // Debugging: Log the updated PYOItems array
//   console.log(PYOItems);
//   savePYOItems(); // Assuming savePYOItems is an async function
// }





async function loadPYOItems() {

       let cartData = await getCartData();
       let cartItems = cartData.items;
        let filteredPYOItems = PYOItems.filter(pyoItem => 
          cartItems.some(cartItem => cartItem.id === parseInt(pyoItem.id))
        );
  
        PYOItems = filteredPYOItems;
        savePYOItems();

 
       let html = selectionHTML();
        document.querySelector('[data-result-listing]').innerHTML = html;
        document.querySelectorAll('[data-qty-container]')?.forEach((container) => {
        const variantID = container.getAttribute('data-pro-variant');
        const qtyInput = container.querySelector('[data-qty-input]');

        // Count the occurrences of this variantID in the stored PYOItems
        const quantity = PYOItems.filter(item => item.id === variantID).length;

        if (quantity > 0) {
            // Set the quantity input value to the count
            qtyInput.value = quantity;
        } else {
            // If no matching item, default to 'ADD'
            qtyInput.value = 'ADD';
        }

       

          let PYOLength = PYOItems.length;
           if(PYOLength >= 50){
              qtyIncreaseBtn.forEach((btn) => {
                  btn.classList.add('disabled')
              })
             qtyInputs.forEach((btn) => {
                  btn.classList.add('disabled')
              })
             
           } else if(PYOLength < 50){
              qtyIncreaseBtn.forEach((btn) => {
                  btn.classList.remove('disabled')
              })
             qtyInputs.forEach((btn) => {
                  btn.classList.remove('disabled')
              })
           }
          
            if(PYOLength > 0){
              checkoutBtn.forEach((button) => {
                button.classList.remove('disabled')
                button.removeAttribute('disabled')
              });
              document.querySelector('.pyo-sticky-sec .pyo-summary').classList.add('open');
            
            } else {
              checkoutBtn.forEach((button) => {
                button.classList.add('disabled')
                button.setAttribute('disabled','disabled')
              });
              document.querySelector('.pyo-sticky-sec .pyo-summary').classList.remove('open');
            }

           let totalPrice = 0;
          let compareTotalPrice = 0
            
          const allQtyInputs = document.querySelectorAll('[data-qty-input]');
  
  
          allQtyInputs.forEach(input => {
              let proPrice = input.closest('[data-qty-container]').getAttribute('data-price');
              let comparePrice = input.closest('[data-qty-container]').getAttribute('data-compare-price');
      
              let qty = parseInt(input.value) || 0; // Get current quantity
              totalPrice += proPrice * qty; // Sum up total price
              compareTotalPrice += comparePrice * qty; // Sum up compare price
          });

          
            let formattedCPrice = `$${(compareTotalPrice / 100).toFixed(2)}`; // Divide by 100 and format to 2 decimal places
          
            if(compareTotalPrice > 0){
              document.querySelector('[data-pack-price] [data-pack-compare-price]').innerHTML = formattedCPrice;
            }

              let discountPerItem = 0;
              if (PYOLength >= 5 && PYOLength < 10) {
                  discountPerItem = 5.2; // Discount of 5.2 per item
              } else if (PYOLength >= 10) {
                  discountPerItem = 6.95; // Discount of 6.95 per item
              }

              let totalDiscountAmount;

              if(discountPerItem > 0){
                 totalDiscountAmount = discountPerItem * PYOLength
              }



              let formattedPrice;

              if (PYOLength >= 5 && PYOLength < 10) {
                // Subtract 30% of totalPrice if length is between 5 and 9
                formattedPrice = `$${((totalPrice / 100) - totalDiscountAmount).toFixed(2)}`;
                
                 document.querySelector('[data-pack-price] [data-pack-compare-price]').innerHTML = `$${(totalPrice / 100).toFixed(2)}`;
                 document.querySelector('[data-pack-compare-price-mobile]').innerHTML = `<span class="dashed">-</span>$${(totalPrice / 100).toFixed(2)}`;
              } else if (PYOLength >= 10) {
                // Subtract 40% of totalPrice if length is exactly 10
                formattedPrice = `$${((totalPrice / 100) - totalDiscountAmount).toFixed(2)}`;
                document.querySelector('[data-pack-price] [data-pack-compare-price]').innerHTML = `$${(totalPrice / 100).toFixed(2)}`;
                document.querySelector('[data-pack-compare-price-mobile]').innerHTML = `<span class="dashed">-</span>$${(totalPrice / 100).toFixed(2)}`;

              } else {
                // Default case: full price
                formattedPrice = `$${(totalPrice / 100).toFixed(2)}`;
                document.querySelector('[data-pack-price] [data-pack-compare-price]').innerHTML = '';
                document.querySelector('[data-pack-compare-price-mobile]').innerHTML = `<span class="dashed">-</span>`;
              }


          
                    
           
            
             document.querySelector('[data-pack-price] [data-pack-price-total]').innerHTML = formattedPrice;
             document.querySelector('[data-total-price-pack]').innerHTML = formattedPrice;
          
          
            
          
            if(PYOLength < 5){
              let left_count = 5 - PYOLength;
              document.querySelector('[data-got-offer]').classList.add('hide');
              document.querySelector('[data-second-offer]').classList.add('hide');
              document.querySelector('[data-first-offer]').classList.remove('hide');
              document.querySelector('[data-first-left]').innerHTML = left_count;
            } else if(PYOLength >= 5 && PYOLength < 10){
              let left_count_new = 10 - PYOLength;
              document.querySelector('[data-got-offer]').classList.add('hide')
              document.querySelector('[data-second-offer]').classList.remove('hide')
              document.querySelector('[data-first-offer]').classList.add('hide')
              document.querySelector('[data-second-left]').innerHTML = left_count_new;
          
            } else {
              document.querySelector('[data-got-offer]').classList.remove('hide')
              document.querySelector('[data-second-offer]').classList.add('hide')
              document.querySelector('[data-first-offer]').classList.add('hide')
          
          
            }


           // Toggle visibility based on itemCount
    discounted.forEach(function(el) {
      el.style.display = (PYOLength >= 5 && PYOLength < 10) ? 'block' : 'none';
    });
    
    
    discounted10.forEach(function(el) {
      el.style.display = (PYOLength >= 10) ? 'block' : 'none';
    });
    
    discountedCp.forEach(function(el) {
      el.style.display = (PYOLength >= 5 && PYOLength < 10) ? 'block' : 'none';
    });
    
    discounted10Cp.forEach(function(el) {
      el.style.display = (PYOLength >= 10) ? 'block' : 'none';
    });

          if(PYOLength < 5){
            document.querySelectorAll('.money.orginal_price').forEach((el) =>{
              el.classList.remove('price_over_5')
            });
             document.querySelectorAll('.money.orginal_price_cp').forEach((el) =>{
              el.classList.remove('price_over_5')
            });
              document.querySelectorAll('.money.orginal_price_cp').forEach((el) =>{
              el.style.display = 'block';
            });
             document.querySelectorAll('.money.orginal_price').forEach((el) =>{
              el.style.display = 'block';
            });
          } else {
              document.querySelectorAll('.money.orginal_price').forEach((el) =>{
                el.classList.add('price_over_5')
              });
               document.querySelectorAll('.money.orginal_price_cp').forEach((el) =>{
              el.classList.add('price_over_5')
            });
              
            
          }


    



          
          
           progressItems.forEach(item => item.classList.remove('active'));
           for (let i = 0; i < PYOItems.length && i < progressItems.length; i++) {
              progressItems[i].classList.add('active');
           }
          
             progressItemsSticky.forEach(item => item.classList.remove('active'));
           for (let i = 0; i < PYOItems.length && i < progressItemsSticky.length; i++) {
              progressItemsSticky[i].classList.add('active');
           }



          

          
    });
 //  } else {
 //    const totalItems = 10;
 //    let selectedProductHTML = '';
 //    let combinedItemCount = 0; 
 //    const defaultDivCount = totalItems - PYOItems.length;
 //    for (let i = 0; i < defaultDivCount; i++) {
 //        if (combinedItemCount === 4) {
 //            // HTML for the 5th item (if in default)
 //            selectedProductHTML += `
 //                <div class="col-custom">
 //                    <div class="pro-image-wrapper">
 //                        <div class="offer-tag"><span>30%</span>OFF</div>
 //                        <div class="svg-image" data-selected-item-image>
 //                          <svg width="70" height="84" viewBox="0 0 70 84" fill="none" xmlns="http://www.w3.org/2000/svg">
 //                              <path d="M68.4985 1.42541C60.33 0.431723 43.9929 2.61783 43.9929 19.3117C43.9929 40.1791 62.9015 31.662 67.8934 50.8259" stroke="#9F9084" stroke-width="1.8" stroke-dasharray="4.68 4.68"/>
 //                              <path d="M35.0684 1.2124H68.3475V49.3352C68.3475 64.0275 65.5177 82.3397 35.0684 82.3397" stroke="#9F9084" stroke-width="1.8" stroke-dasharray="4.68 4.68"/>
 //                              <path d="M1.638 1.42541C9.80652 0.431723 26.1436 2.61783 26.1436 19.3117C26.1436 40.1791 7.23495 31.662 2.24307 50.8259" stroke="#9F9084" stroke-width="1.8" stroke-dasharray="4.68 4.68"/>
 //                              <path d="M35.0684 1.2124H1.78921V49.3352C1.78921 64.0275 4.619 82.3397 35.0684 82.3397" stroke="#9F9084" stroke-width="1.8" stroke-dasharray="4.68 4.68"/>
 //                          </svg>
 //                      </div>
 //                    </div>
 //                </div>
 //            `;
 //        } else if (combinedItemCount === 9) {
 //            // HTML for the 10th item (if in default)
 //            selectedProductHTML += `
 //                <div class="col-custom">
 //                    <div class="pro-image-wrapper">
 //                        <div class="offer-tag"><span>40%</span>OFF</div>
 //                        <div class="svg-image" data-selected-item-image>
 //                            <svg width="70" height="84" viewBox="0 0 70 84" fill="none" xmlns="http://www.w3.org/2000/svg">
 //                                <path d="M68.4985 1.42541C60.33 0.431723 43.9929 2.61783 43.9929 19.3117C43.9929 40.1791 62.9015 31.662 67.8934 50.8259" stroke="#9F9084" stroke-width="1.8" stroke-dasharray="4.68 4.68"/>
 //                                <path d="M35.0684 1.2124H68.3475V49.3352C68.3475 64.0275 65.5177 82.3397 35.0684 82.3397" stroke="#9F9084" stroke-width="1.8" stroke-dasharray="4.68 4.68"/>
 //                                <path d="M1.638 1.42541C9.80652 0.431723 26.1436 2.61783 26.1436 19.3117C26.1436 40.1791 7.23495 31.662 2.24307 50.8259" stroke="#9F9084" stroke-width="1.8" stroke-dasharray="4.68 4.68"/>
 //                                <path d="M35.0684 1.2124H1.78921V49.3352C1.78921 64.0275 4.619 82.3397 35.0684 82.3397" stroke="#9F9084" stroke-width="1.8" stroke-dasharray="4.68 4.68"/>
 //                            </svg>
 //                        </div>
 //                    </div>
 //                </div>
 //            `;
 //        } else {
 //            // Default HTML for other default items
 //            selectedProductHTML += `
 //                <div class="col-custom">
 //                    <div class="pro-image-wrapper">
 //                         <div class="svg-image" data-selected-item-image>
 //                            <svg width="70" height="84" viewBox="0 0 70 84" fill="none" xmlns="http://www.w3.org/2000/svg">
 //                                <path d="M68.4985 1.42541C60.33 0.431723 43.9929 2.61783 43.9929 19.3117C43.9929 40.1791 62.9015 31.662 67.8934 50.8259" stroke="#9F9084" stroke-width="1.8" stroke-dasharray="4.68 4.68"/>
 //                                <path d="M35.0684 1.2124H68.3475V49.3352C68.3475 64.0275 65.5177 82.3397 35.0684 82.3397" stroke="#9F9084" stroke-width="1.8" stroke-dasharray="4.68 4.68"/>
 //                                <path d="M1.638 1.42541C9.80652 0.431723 26.1436 2.61783 26.1436 19.3117C26.1436 40.1791 7.23495 31.662 2.24307 50.8259" stroke="#9F9084" stroke-width="1.8" stroke-dasharray="4.68 4.68"/>
 //                                <path d="M35.0684 1.2124H1.78921V49.3352C1.78921 64.0275 4.619 82.3397 35.0684 82.3397" stroke="#9F9084" stroke-width="1.8" stroke-dasharray="4.68 4.68"/>
 //                            </svg>
 //                        </div>
 //                    </div>
 //                </div>
 //            `;
 //        }
 //        combinedItemCount++; // Increment combined count
 //    }

 //     document.querySelector('[data-result-listing]').innerHTML = selectedProductHTML;
 // document.querySelector('.pyo-sticky-sec .pyo-summary').classList.remove('open');
    
 //  }
   
}

loadPYOItems();


qtyChangeBtn.forEach((button) => {
    button.addEventListener('click', (event) => {
        manageQtyBtn(event)
        let inputs = event.target.closest('.pro-product-listing').querySelectorAll('[data-qty-container] a');
        inputs.forEach(input => {
            input.classList.add('disabled'); 
        });

      setTimeout(() => {
        inputs.forEach(input => {
            input.classList.remove('disabled'); 
        });
      },2000)
    
    });
});

qtyInputs.forEach((input) => {
    input.addEventListener('click', (event) => {
        event.preventDefault();

        if (input.value === 'ADD') {
            // Find the associated increase button
            const increaseButton = input.closest('[data-qty-container]').querySelector('[data-increase-qty]');
            if (increaseButton) {
                // Directly call the click method instead of dispatching a synthetic event
                increaseButton.click();
            }
        }
    });
});






function manageQtyBtn(event) {
    event.preventDefault();
    let currentTarget = event.currentTarget;
   
    let action = currentTarget.dataset.for;
    let $qtyInput = currentTarget.closest('[data-qty-container]').querySelector('[data-qty-input]');
    let qtyInputVal = parseInt($qtyInput.value);
    let currentQty = 0;
    if (!isNaN(qtyInputVal)) {
        currentQty = qtyInputVal;
    }
    //let currentQty = parseInt($qtyInput.value) || 0;
    let finalQty = 1;
    let variantID = currentTarget.closest('[data-qty-container]').getAttribute('data-pro-variant');
    let imageSrc = currentTarget.closest('[data-qty-container]').getAttribute('data-pro-image');

    let totalPrice = 0;
    let compareTotalPrice = 0

    if(action == 'decrease'){
      finalQty = currentQty - 1;
      removeItem(variantID,finalQty)
    } else {
      finalQty = currentQty + 1;
      addItem(variantID,1);

    }
  
     

    if(finalQty < 1){
      $qtyInput.value = 'ADD';
    } else {
      $qtyInput.value = finalQty;
    }
    const allQtyInputs = document.querySelectorAll('[data-qty-input]');


      allQtyInputs.forEach(input => {
        let proPrice = input.closest('[data-qty-container]').getAttribute('data-price');
        let comparePrice = input.closest('[data-qty-container]').getAttribute('data-compare-price');

        let qty = parseInt(input.value) || 0; // Get current quantity
        totalPrice += proPrice * qty; // Sum up total price
        compareTotalPrice += comparePrice * qty; // Sum up compare price
    });

    

    

    managePYOSelection(action,variantID,imageSrc,totalPrice,compareTotalPrice,finalQty);
}

async function managePYOSelection(action,variantID,imageSrc,totalPrice,comapreTotalPrice,finalQty){
 if(action === 'decrease'){
    removeFirstProductById(variantID);
 } else {
    let product = {
        "id":variantID,
        "image_src":imageSrc,
        "quantity":finalQty
    }
    PYOItems.push(product);
 }

 savePYOItems();


 let PYOLength = PYOItems.length;
 if(PYOLength >= 50){
    qtyIncreaseBtn.forEach((btn) => {
        btn.classList.add('disabled')
    })
   qtyInputs.forEach((btn) => {
        btn.classList.add('disabled')
    })
   
 } else if(PYOLength < 50){
    qtyIncreaseBtn.forEach((btn) => {
        btn.classList.remove('disabled')
    })
   qtyInputs.forEach((btn) => {
        btn.classList.remove('disabled')
    })
 }


    
     discounted.forEach(function(el) {
      el.style.display = (PYOLength >= 5 && PYOLength < 10) ? 'block' : 'none';
    });
    
    
    discounted10.forEach(function(el) {
      el.style.display = (PYOLength >= 10) ? 'block' : 'none';
    });
    
    discountedCp.forEach(function(el) {
      el.style.display = (PYOLength >= 5 && PYOLength < 10) ? 'block' : 'none';
    });
    
    discounted10Cp.forEach(function(el) {
      el.style.display = (PYOLength >= 10) ? 'block' : 'none';
    });

         if(PYOLength < 5){
            document.querySelectorAll('.money.orginal_price').forEach((el) =>{
              el.classList.remove('price_over_5')
            });
           document.querySelectorAll('.money.orginal_price_cp').forEach((el) =>{
              el.classList.remove('price_over_5')
            });
             document.querySelectorAll('.money.orginal_price_cp').forEach((el) =>{
              el.style.display = 'block';
            });
             document.querySelectorAll('.money.orginal_price').forEach((el) =>{
              el.style.display = 'block';
            });
          } else {
              document.querySelectorAll('.money.orginal_price').forEach((el) =>{
                el.classList.add('price_over_5')
              });
               document.querySelectorAll('.money.orginal_price_cp').forEach((el) =>{
              el.classList.add('price_over_5')
            });
            
          }


    
    

  if(PYOLength > 0){
    checkoutBtn.forEach((button) => {
      button.classList.remove('disabled')
      button.removeAttribute('disabled')
    });
    document.querySelector('.pyo-sticky-sec .pyo-summary').classList.add('open');
  
  } else {
    checkoutBtn.forEach((button) => {
      button.classList.add('disabled')
      button.setAttribute('disabled','disabled')
    });
    document.querySelector('.pyo-sticky-sec .pyo-summary').classList.remove('open');
  }

   let formattedCPrice = `$${(comapreTotalPrice / 100).toFixed(2)}`; // Divide by 100 and format to 2 decimal places

  if(comapreTotalPrice > 0){
    document.querySelector('[data-pack-price] [data-pack-compare-price]').innerHTML = formattedCPrice;
  }

              let discountPerItem = 0;
              if (PYOLength >= 5 && PYOLength < 10) {
                  discountPerItem = 5.2; // Discount of 5.2 per item
              } else if (PYOLength >= 10) {
                  discountPerItem = 6.95; // Discount of 6.95 per item
              }

              let totalDiscountAmount;

              if(discountPerItem > 0){
                 totalDiscountAmount = discountPerItem * PYOLength
              }



              let formattedPrice;

              if (PYOLength >= 5 && PYOLength < 10) {
                // Subtract 30% of totalPrice if length is between 5 and 9
                formattedPrice = `$${((totalPrice / 100) - totalDiscountAmount).toFixed(2)}`;
                
                 document.querySelector('[data-pack-price] [data-pack-compare-price]').innerHTML = `$${(totalPrice / 100).toFixed(2)}`;
                 document.querySelector('[data-pack-compare-price-mobile]').innerHTML = `<span class="dashed">-</span>$${(totalPrice / 100).toFixed(2)}`;
              } else if (PYOLength >= 10) {
                // Subtract 40% of totalPrice if length is exactly 10
                formattedPrice = `$${((totalPrice / 100) - totalDiscountAmount).toFixed(2)}`;
                document.querySelector('[data-pack-price] [data-pack-compare-price]').innerHTML = `$${(totalPrice / 100).toFixed(2)}`;
                document.querySelector('[data-pack-compare-price-mobile]').innerHTML = `<span class="dashed">-</span>$${(totalPrice / 100).toFixed(2)}`;

              } else {
                // Default case: full price
                formattedPrice = `$${(totalPrice / 100).toFixed(2)}`;
                document.querySelector('[data-pack-price] [data-pack-compare-price]').innerHTML = '';
                document.querySelector('[data-pack-compare-price-mobile]').innerHTML = `<span class="dashed">-</span>`;
              }


          
                    
           


  
   document.querySelector('[data-pack-price] [data-pack-price-total]').innerHTML = formattedPrice;
   document.querySelector('[data-total-price-pack]').innerHTML = formattedPrice;


  if(PYOLength < 5){
    let left_count = 5 - PYOLength;
    document.querySelector('[data-got-offer]').classList.add('hide');
    document.querySelector('[data-second-offer]').classList.add('hide');
    document.querySelector('[data-first-offer]').classList.remove('hide');
    document.querySelector('[data-first-left]').innerHTML = left_count;
  } else if(PYOLength >= 5 && PYOLength < 10){
    let left_count_new = 10 - PYOLength;
    document.querySelector('[data-got-offer]').classList.add('hide')
    document.querySelector('[data-second-offer]').classList.remove('hide')
    document.querySelector('[data-first-offer]').classList.add('hide')
    document.querySelector('[data-second-left]').innerHTML = left_count_new;

  } else {
    document.querySelector('[data-got-offer]').classList.remove('hide')
    document.querySelector('[data-second-offer]').classList.add('hide')
    document.querySelector('[data-first-offer]').classList.add('hide')


  }

 progressItems.forEach(item => item.classList.remove('active'));
 for (let i = 0; i < PYOItems.length && i < progressItems.length; i++) {
    progressItems[i].classList.add('active');
 }

   progressItemsSticky.forEach(item => item.classList.remove('active'));
 for (let i = 0; i < PYOItems.length && i < progressItemsSticky.length; i++) {
    progressItemsSticky[i].classList.add('active');
 }


  

 var html = await selectionHTML();
 document.querySelector('[data-result-listing]').innerHTML = html;

}

function removeFirstProductById(id) {
    const index = PYOItems.findIndex(item => item.id === id);
    if (index !== -1) {
        PYOItems.splice(index, 1);
    }
}

function selectionHTML(){

    const totalItems = 10;
    let selectedProductHTML = '';

    const defaultDivCount = totalItems - PYOItems.length;


  let combinedItemCount = 0; // Track the combined index
  // First, iterate over PYOItems
  PYOItems.forEach((item) => {
      if (combinedItemCount === 4) {
          // HTML for the 5th item
          selectedProductHTML += `
              <div class="col-custom">
                  <div class="pro-image-wrapper">
                      <span class="close-icon" data-remove-pack="${item.id}">
                          <svg width="13" height="13" viewBox="0 0 13 13" fill="none">
                            <path d="M9.31055 3.02026L3.08625 9.24456" stroke="white" stroke-width="1.42743"/>
                            <path d="M9.47852 9.24487L3.25422 3.02057" stroke="white" stroke-width="1.42743"/>
                          </svg>
                      </span>
                      <div class="offer-tag"><span>30%</span>OFF</div>
                      <div data-selected-item-image>
                          <img src="${item.image_src.startsWith('http') ? item.image_src : 'https:' + item.image_src}" alt="Image of product ${item.id}" />
                      </div>
                  </div>
              </div>
          `;
      } else if (combinedItemCount === 9) {
          // HTML for the 10th item
          selectedProductHTML += `
              <div class="col-custom">
                  <div class="pro-image-wrapper">
                      <span class="close-icon" data-remove-pack="${item.id}">
                          <svg width="13" height="13" viewBox="0 0 13 13" fill="none">
                            <path d="M9.31055 3.02026L3.08625 9.24456" stroke="white" stroke-width="1.42743"/>
                            <path d="M9.47852 9.24487L3.25422 3.02057" stroke="white" stroke-width="1.42743"/>
                          </svg>
                      </span>
                      <div class="offer-tag"><span>40%</span>OFF</div>
                      <div data-selected-item-image>
                          <img src="${item.image_src.startsWith('http') ? item.image_src : 'https:' + item.image_src}" alt="Image of product ${item.id}" />
                      </div>
                  </div>
              </div>
          `;
      } else {
          // Default HTML for other PYOItems
          selectedProductHTML += `
              <div class="col-custom">
                  <div class="pro-image-wrapper">
                       <span class="close-icon" data-remove-pack="${item.id}">
                          <svg width="13" height="13" viewBox="0 0 13 13" fill="none">
                            <path d="M9.31055 3.02026L3.08625 9.24456" stroke="white" stroke-width="1.42743"/>
                            <path d="M9.47852 9.24487L3.25422 3.02057" stroke="white" stroke-width="1.42743"/>
                          </svg>
                      </span>
                      <div data-selected-item-image>
                          <img src="${item.image_src.startsWith('http') ? item.image_src : 'https:' + item.image_src}" alt="Image of product ${item.id}" />
                      </div>
                  </div>
              </div>
          `;
      }
      combinedItemCount++; // Increment combined count
  });

  // Then, add default items up to `defaultDivCount`
  for (let i = 0; i < defaultDivCount; i++) {
      if (combinedItemCount === 4) {
          // HTML for the 5th item (if in default)
          selectedProductHTML += `
              <div class="col-custom">
                  <div class="pro-image-wrapper">
                      <div class="offer-tag"><span>30%</span>OFF</div>
                      <div class="svg-image" data-selected-item-image>
                        <svg width="70" height="84" viewBox="0 0 70 84" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M68.4985 1.42541C60.33 0.431723 43.9929 2.61783 43.9929 19.3117C43.9929 40.1791 62.9015 31.662 67.8934 50.8259" stroke="#9F9084" stroke-width="1.8" stroke-dasharray="4.68 4.68"/>
                            <path d="M35.0684 1.2124H68.3475V49.3352C68.3475 64.0275 65.5177 82.3397 35.0684 82.3397" stroke="#9F9084" stroke-width="1.8" stroke-dasharray="4.68 4.68"/>
                            <path d="M1.638 1.42541C9.80652 0.431723 26.1436 2.61783 26.1436 19.3117C26.1436 40.1791 7.23495 31.662 2.24307 50.8259" stroke="#9F9084" stroke-width="1.8" stroke-dasharray="4.68 4.68"/>
                            <path d="M35.0684 1.2124H1.78921V49.3352C1.78921 64.0275 4.619 82.3397 35.0684 82.3397" stroke="#9F9084" stroke-width="1.8" stroke-dasharray="4.68 4.68"/>
                        </svg>
                    </div>
                  </div>
              </div>
          `;
      } else if (combinedItemCount === 9) {
          // HTML for the 10th item (if in default)
          selectedProductHTML += `
              <div class="col-custom">
                  <div class="pro-image-wrapper">
                      <div class="offer-tag"><span>40%</span>OFF</div>
                      <div class="svg-image" data-selected-item-image>
                          <svg width="70" height="84" viewBox="0 0 70 84" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M68.4985 1.42541C60.33 0.431723 43.9929 2.61783 43.9929 19.3117C43.9929 40.1791 62.9015 31.662 67.8934 50.8259" stroke="#9F9084" stroke-width="1.8" stroke-dasharray="4.68 4.68"/>
                              <path d="M35.0684 1.2124H68.3475V49.3352C68.3475 64.0275 65.5177 82.3397 35.0684 82.3397" stroke="#9F9084" stroke-width="1.8" stroke-dasharray="4.68 4.68"/>
                              <path d="M1.638 1.42541C9.80652 0.431723 26.1436 2.61783 26.1436 19.3117C26.1436 40.1791 7.23495 31.662 2.24307 50.8259" stroke="#9F9084" stroke-width="1.8" stroke-dasharray="4.68 4.68"/>
                              <path d="M35.0684 1.2124H1.78921V49.3352C1.78921 64.0275 4.619 82.3397 35.0684 82.3397" stroke="#9F9084" stroke-width="1.8" stroke-dasharray="4.68 4.68"/>
                          </svg>
                      </div>
                  </div>
              </div>
          `;
      } else {
          // Default HTML for other default items
          selectedProductHTML += `
              <div class="col-custom">
                  <div class="pro-image-wrapper">
                       <div class="svg-image" data-selected-item-image>
                          <svg width="70" height="84" viewBox="0 0 70 84" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M68.4985 1.42541C60.33 0.431723 43.9929 2.61783 43.9929 19.3117C43.9929 40.1791 62.9015 31.662 67.8934 50.8259" stroke="#9F9084" stroke-width="1.8" stroke-dasharray="4.68 4.68"/>
                              <path d="M35.0684 1.2124H68.3475V49.3352C68.3475 64.0275 65.5177 82.3397 35.0684 82.3397" stroke="#9F9084" stroke-width="1.8" stroke-dasharray="4.68 4.68"/>
                              <path d="M1.638 1.42541C9.80652 0.431723 26.1436 2.61783 26.1436 19.3117C26.1436 40.1791 7.23495 31.662 2.24307 50.8259" stroke="#9F9084" stroke-width="1.8" stroke-dasharray="4.68 4.68"/>
                              <path d="M35.0684 1.2124H1.78921V49.3352C1.78921 64.0275 4.619 82.3397 35.0684 82.3397" stroke="#9F9084" stroke-width="1.8" stroke-dasharray="4.68 4.68"/>
                          </svg>
                      </div>
                  </div>
              </div>
          `;
      }
      combinedItemCount++; // Increment combined count
  }
  

   

   

  return selectedProductHTML;

}



function addItem(variantID,finalQty){
  let formData = {
     id: variantID,
     quantity: finalQty
  };

  // Make the POST request to add items to the cart
  fetch(window.Shopify.routes.root + 'cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(formData)
  })
  .then(response => {
    if (response.ok) {
      // Redirect to checkout on successful response
      //location.href = '/checkout';
    } else {
      console.error('Failed to add items to cart:', response);
    }
  })
  .catch((error) => {
    console.error('Error:', error);
  });
}

function removeItem(variantID,qty) {
  let formData = {
    id: variantID,
    quantity: qty
  };

  console.log(formData);

  // Make the POST request to remove item from the cart
  fetch(window.Shopify.routes.root + 'cart/change.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(formData)
  })
  .then(response => {
    if (response.ok) {
      console.log('Item successfully removed from cart');
    } else {
      console.error('Failed to remove item from cart:', response);
    }
  })
  .catch((error) => {
    console.error('Error:', error);
  });
}



// checkoutBtn.forEach((button) => {
//   button.addEventListener('click', (event) => {
//     event.preventDefault();
//     location.href = '/checkout';
//     // // Initialize a new itemsMap for each click
//     // let itemsMap = {};

//     // // Function to add items to the itemsMap
//     // function addItemsToMap(array) {
//     //   array.forEach((item) => {
//     //     let itemID = item.id; // Get the item ID
//     //     let quantity = 1; // Default to 1 if quantity is not available

//     //     // If the ID already exists in the map, increment the quantity
//     //     if (itemsMap[itemID]) {
//     //       itemsMap[itemID].quantity += quantity;
//     //     } else {
//     //       // If it doesn't exist, create a new entry
//     //       itemsMap[itemID] = {
//     //         id: itemID,
//     //         quantity: quantity
//     //       };
//     //     }
//     //   });
//     // }

//     // // Add items from both arrays to itemsMap
//     // addItemsToMap(PYOItems);
//     // addItemsToMap(FreqItems);

//     // // Convert the itemsMap object back to an array
//     // let items = Object.values(itemsMap);

//     // // Prepare formData for the API request
//     // let formData = {
//     //   items: items
//     // };

//     // // Make the POST request to add items to the cart
//     // fetch(window.Shopify.routes.root + 'cart/add.js', {
//     //   method: 'POST',
//     //   headers: {
//     //     'Content-Type': 'application/json'
//     //   },
//     //   body: JSON.stringify(formData)
//     // })
//     // .then(response => {
//     //   if (response.ok) {
//     //     // Redirect to checkout on successful response
//     //     location.href = '/checkout';
//     //   } else {
//     //     console.error('Failed to add items to cart:', response);
//     //   }
//     // })
//     // .catch((error) => {
//     //   console.error('Error:', error);
//     // });

//     // // For debugging: Check the final formData structure
//     // console.log(formData);
//   });
// });


// Select the elements
const pyoPage = document.querySelector('.pyo-page');
const stickySteps = document.querySelector('.sticky-steps');

// Create an intersection observer
const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
        if (!entry.isIntersecting) {
            // Remove the class when pyo-page is not in the viewport
            stickySteps.classList.remove('hide');
        } else {
            // Optionally, add the class back if needed
            stickySteps.classList.add('hide');
        }
    });
}, {
    threshold: 0 // Adjust this threshold as needed
});

// Start observing the pyo-page element
if (pyoPage) {
    observer.observe(pyoPage);
}



document.querySelectorAll('.cc-btn').forEach((button) => {
  button.addEventListener('click', (event) => {
     event.preventDefault(); 
    const targetSection = document.getElementById('pyo-selection');
    const offset = 100; // Offset of 100px above the target element
    const targetPosition = targetSection.getBoundingClientRect().top + window.scrollY - offset;
    const startPosition = window.scrollY;
    const distance = targetPosition - startPosition;
    const duration = 1000; // Duration in milliseconds (1 second)
    let startTime = null;

    function smoothScroll(currentTime) {
      if (startTime === null) startTime = currentTime;
      const timeElapsed = currentTime - startTime;
      const scrollAmount = easeInOutQuad(timeElapsed, startPosition, distance, duration);

      window.scrollTo(0, scrollAmount);

      if (timeElapsed < duration) {
        requestAnimationFrame(smoothScroll);
      }
    }

    // Easing function for a smoother scroll effect
    function easeInOutQuad(t, b, c, d) {
      t /= d / 2;
      if (t < 1) return (c / 2) * t * t + b;
      t--;
      return (-c / 2) * (t * (t - 2) - 1) + b;
    }

    requestAnimationFrame(smoothScroll);
  });
});


//Frequently Bought Together JS



let qtyChangeFrqBtn = document.querySelectorAll('[data-qty-btn-frq]');
console.log(qtyChangeFrqBtn,'hiiiiiiii');
qtyChangeFrqBtn.forEach((button) => {
    button.addEventListener('click', (event) => {
        manageQtyFrqBtn(event)
    });
});

function manageQtyFrqBtn(event){
    event.preventDefault();
    let currentTarget = event.currentTarget;
    let action = currentTarget.dataset.for;
    let $qtyInput = currentTarget.closest('[data-qty-container-frq]').querySelector('[data-qty-input-frq]');
    let qtyInputVal = parseInt($qtyInput.value);
    let currentQty = qtyInputVal;
   
    console.log('helloooo',action);
    //let currentQty = parseInt($qtyInput.value) || 0;
    let finalQty = 1;
    let variantID = currentTarget.closest('[data-qty-container-frq]').getAttribute('data-pro-variant');

    if(action == 'decrease'){
      finalQty = currentQty - 1;
      removeItem(variantID,finalQty)
    } else {
      finalQty = currentQty + 1;
      addItem(variantID,1);


    }

  
     
    $qtyInput.value = finalQty;

    //manageFrqSelection(action,variantID,finalQty);
   
    
}

// function manageFrqSelection(action,variantID,finalQty){
//    if(action === 'decrease'){
//       removeFirstProductById(variantID);
//    } else {
//       let product = {
//           "id":variantID,
//           "quantity":finalQty
//       }
//       FreqItems.push(product);
//    }
// }

var galleryCaption = new Swiper("[data-pyo-video-slider]", {
  speed: 500,
  slidesPerView: "auto",
  simulateTouch: true,
  spaceBetween: 20,
  navigation: {
    nextEl: ".video-next",
    prevEl: ".video-prev",
  }, 
});





const playIcons = document.querySelectorAll('.cc-video-overlay');

playIcons.forEach((element) => {
  element.addEventListener('click', (event) => {
    console.log(event);
    const videoItem = event.target.closest('.cc-video-wrapper');
    if (videoItem) {
      // Find all videos and pause any that are playing
      document.querySelectorAll('.cc-video-wrapper video').forEach((video) => {
        if (!video.paused) {
          video.pause();
          video.controls = false; // Hide controls for paused videos
           
           document.querySelectorAll('.cc-video-slider .swiper-slide').forEach((el) => {
            el.classList.remove('active-slide');
            el.classList.remove('active-slide-play');
          });
        }
      });

      // Hide the play button for the clicked video and play it
      
      const video = videoItem.querySelector('video');
      if (video) {
        video.controls = true; // Show controls for the active video
        video.play();
      }

      // Update active slide
      document.querySelectorAll('.cc-video-slider .swiper-slide').forEach((el) => {
        el.classList.remove('active-slide');
        el.classList.remove('active-slide-play');
      });
      event.currentTarget.closest('.swiper-slide').classList.add('active-slide');
      event.currentTarget.closest('.swiper-slide').classList.add('active-slide-play');
    }
  });
});





document.querySelectorAll('.cc-content-img .cc-content-wrap').forEach(function(element) {
  element.addEventListener('click', function() {
    this.classList.toggle('active');
    const sibling = this.parentElement.querySelector('.cc-content-wrap-ans');
    if (sibling) {
      sibling.style.display = sibling.style.display === 'none' || sibling.style.display === '' ? 'block' : 'none';
    }
  });
});
